import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/utils";
import { WhatsAppIcon } from "@/components/WhatsApp";
import { MessagesSquare, FileBadge, Hotel, UserRound, Camera, Compass } from "lucide-react";

const SERVICES = [
  { k: "konsultasi", i: MessagesSquare },
  { k: "visa", i: FileBadge },
  { k: "hotel", i: Hotel },
  { k: "muthawwif", i: UserRound },
  { k: "dokumentasi", i: Camera },
  { k: "la_umroh", i: Compass },
];

export default function OtherServicesPage() {
  const { t } = useApp();
  const [phone, setPhone] = useState("");
  useEffect(() => { api.get("/public/catalog").then((r) => setPhone(r.data.settings.whatsapp)); }, []);
  return (
    <div data-testid="other-services-page">
      <section className="abdan-hero-grid">
        <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-16">
          <div className="text-xs uppercase tracking-widest text-emerald-700 font-bold mb-3">{t("other_services")}</div>
          <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight max-w-3xl">{t("other_services_title")}</h1>
          <p className="text-lg text-slate-600 mt-6 max-w-2xl leading-relaxed">{t("other_services_sub")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => { const I = s.i;
            return (
              <div key={s.k} className="abdan-card p-6 flex flex-col" data-testid={`osvc-${s.k}`}>
                <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 grid place-items-center mb-4"><I className="w-6 h-6" /></div>
                <h3 className="font-bold text-xl mb-2">{t(`osvc_${s.k}`)}</h3>
                <p className="text-slate-600 text-sm leading-relaxed flex-1">{t(`osvc_${s.k}_desc`)}</p>
                <a href={waLink(phone, t("osvc_wa_msg").replace("{svc}", t(`osvc_${s.k}`)))} target="_blank" rel="noreferrer" className="mt-5" data-testid={`osvc-wa-${s.k}`}>
                  <Button className="w-full bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full"><WhatsAppIcon className="w-5 h-5 mr-2" />{t("ask_via_wa")}</Button>
                </a>
              </div>);
          })}
        </div>
        <div className="mt-12 rounded-3xl bg-slate-900 text-white p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div><div className="text-emerald-400 text-xs uppercase tracking-widest font-bold mb-2">{t("need_help")}</div>
            <h2 className="text-2xl md:text-3xl font-bold">{t("osvc_cta_title")}</h2><p className="text-slate-300 mt-2">{phone}</p></div>
          <a href={waLink(phone, t("wa_help_msg"))} target="_blank" rel="noreferrer" data-testid="osvc-cta-wa">
            <Button size="lg" className="bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full px-8"><WhatsAppIcon className="w-5 h-5 mr-2" />WhatsApp</Button></a>
        </div>
      </section>
    </div>
  );
}
